export const SCRIPT_BLOCKED_TYPE = 'text/plain'
